import graphql__0a84f1a3151e070ed3b5 from "./__generated__/AnswerPreviewCheckBoxes_answer.graphql.js";
import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import { ANSWER_CHOICE_VALUE_OTHER } from "../Answer/AnswerChoiceWithOther";

const AnswerPreviewCheckBoxes = props => {
  const { formattedValues, other, otherValue } = props.answer;
  const { otherFieldLabel } = props.answer.formField;

  const valuesList = formattedValues.map((value, index) => {
    return <li key={index}>{value}</li>;
  });

  if (other) {
    valuesList.push(
      <li key={ANSWER_CHOICE_VALUE_OTHER}>
        <b>{otherFieldLabel}: </b> {otherValue}
      </li>
    );
  }

  return <ul className="form-answer-check-boxes-values">{valuesList}</ul>;
};

export default createFragmentContainer(AnswerPreviewCheckBoxes, {
  answer: graphql__0a84f1a3151e070ed3b5
});
